var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindowRestore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_8085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 1.5H9.75A2.25 2.25 0 007.5 3.75v.75H6v-.75A3.749 3.749 0 019.75 0h10.5A3.749 3.749 0 0124 3.75v10.5A3.749 3.749 0 0120.25 18h-.75v-1.5h.75a2.25 2.25 0 002.25-2.25V3.75a2.25 2.25 0 00-2.25-2.25zM15 7.5H3c-.83 0-1.5.67-1.5 1.5v3h15V9c0-.83-.67-1.5-1.5-1.5zM1.5 21c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5v-7.5h-15V21zM3 6h12c1.655 0 3 1.345 3 3v12c0 1.655-1.345 3-3 3H3c-1.655 0-3-1.345-3-3V9c0-1.655 1.345-3 3-3z",
    fill: "#0084FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_8085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowRestore);
export default __webpack_public_path__ + "static/media/window-restore.bb9c55505d5194bc4fc9a385919e2b42.svg";
export { ForwardRef as ReactComponent };